import app from "Languages/es/app.php";
import calls from "Languages/es/calls.php";
import fields from "Languages/es/fields.php";
import reminders from "Languages/es/reminders.php";
import sombra from "Languages/es/sombra.php";
import validation from "Languages/es/validation.php";
import civicactioncenter from "Languages/es/civicactioncenter/app.php";
import cac from "Languages/es/cac/app.php";

export default {
  app,
  cac: {
    app: cac
  },
  civicactioncenter: {
    app: civicactioncenter
  },
  calls,
  fields,
  reminders,
  sombra,
  validation
};
